<template>
    <div><slot /></div>
</template>

<script>
    import { USER_REQUEST } from "../store/actions/user";

    export default {
        name: "ConnexionLayout",
        components: {
        },
        data: () => ({
            active: null,
        }),
        created: function() {
            if (this.$store.getters.isAuthenticated) {
                this.$store.dispatch(USER_REQUEST);
            }
        }
    }
</script>
